import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CardComponent } from '@app/ui-components/card/card.component';
import { PersonContactCardFormGroup } from './person-contact-form/person-contact-card-form.helper';
import { PersonContactFormComponent } from './person-contact-form/person-contact-form.component';

@Component({
  selector: 'app-person-contact-card',
  imports: [ReactiveFormsModule, PersonContactFormComponent, CardComponent],
  templateUrl: './person-contact-card.component.html',
  styleUrl: './person-contact-card.component.scss',
})
export class PersonContactCardComponent {
  formGroup = input.required<FormGroup<PersonContactCardFormGroup>>();
  title = input.required<string>();
  /** When true, title (e.g. Dr., Mr.) is shown inside the name form. Use in section-e for one-row layout. */
  showTitle = input<boolean>(false);
  disabled = input<boolean>(false);
}
